import { WebClientDetailFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientDetailFetcher';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { IDetailFetcher } from '../fetchers/IDetailFetcher';
import { IListFetcher } from '../fetchers/IListFetcher';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { DataRoleMapper } from '../mappers/DataRoleMapper';
import { IDataRoleDetailInfo, IDataRoleInfo } from '../models/IDataRoleInfo';
import { DeleteDataRolesRequest } from '../ServerApi/requests/DeleteDataRolesRequest';
import { GetDataRoleActionsRequest } from '../ServerApi/requests/GetDataRoleActionsRequest';
import { GetDataRolesRequest } from '../ServerApi/requests/GetDataRolesRequest';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { MoveDataRolesToProjectRequest } from '../ServerApi/requests/MoveDataRolesToProjectRequest';
import { SetDataRolesOwnerRequest } from '../ServerApi/requests/SetDataRolesOwnerRequest';
import { IDataRoleActions } from '../ServerApi/types/IDataRoleActions';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class DataRolesResource implements IListResource<IDataRoleInfo>, IFieldValuesResource, IDetailResource<IDataRoleDetailInfo>, IActionResource<IDataRoleActions> {
  private listFetcher: IListFetcher<IDataRoleInfo> = new WebClientListResourceFetcher(GetDataRolesRequest, ServerApiMapper.dataRoles);
  private detailFetcher: IDetailFetcher<IDataRoleDetailInfo> = new WebClientDetailFetcher('getDataRole', DataRoleMapper.mapDetail);
  private fieldValuesFetcher: IListFetcher<IFieldValue> =  new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<IDataRoleInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<IDataRoleDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'dataRole');
  }

  // Actions
  public actions(id: string): Promise<IDataRoleActions> {
    return WebHttpClient.sendRequest(new GetDataRoleActionsRequest(id));
  }

  public deleteDataRoles(ids: string[]): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteDataRolesRequest(idsBlock)),
      ResultHelper.combineResults
    );
  }

  public moveToProject(targetProjectId: string, dataRoleIds: string[]): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(dataRoleIds, (idsBlock) => new MoveDataRolesToProjectRequest({
        ids: idsBlock,
        projectId: targetProjectId
      })),
      ResultHelper.combineResults);
  }

  public setOwner(ids: string[], ownerId: string): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetDataRolesOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }

  public isDataRoleDetailedInfo(item: any): item is IDataRoleDetailInfo {
    return item &&
           item.contentType &&
           item.contentType === 'dataRole' &&
           item.hasOwnProperty('dataTypes');
  }
}

export const DataRoles = new DataRolesResource();
